// extracted by mini-css-extract-plugin
export var container = "product-module--container--3F5pU";
export var imageContainer = "product-module--imageContainer--3CN5F";
export var image = "product-module--image--3eHyo";
export var description = "product-module--description--1p1Ap";